// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"Avatar_Avatar__GJwbx","NoMargin":"Avatar_NoMargin__1UaYr","MoreMargin":"Avatar_MoreMargin__37Bs4","Letters":"Avatar_Letters__1mkYn","Img":"Avatar_Img__DIrDE"};